
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { reactElement, reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { DialogWithClasses } from "./Dialog.js";
import { createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { join } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { singleton, ofArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { reactApi as reactApi_1 } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import react_signature_canvas from "react-signature-canvas";
import { TextButton } from "./Button.js";

export function SignatureDialog(props) {
    let Title, elems, props_1;
    const t = useTranslation()[0];
    const signaturePad = reactApi.useRef(undefined);
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    return createElement(DialogWithClasses, (Title = t("general.signature"), {
        Body: singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "h-[calc(100vh-13rem)]", "w-[calc(100vw-6.5rem)]"])], (elems = [(props_1 = ofArray([["canvasProps", {
            className: "grow",
        }], ["backgroundColor", "rgb(255, 255, 255)"], ["ref", signaturePad]]), reactApi_1.createElement(react_signature_canvas, createObj(props_1))), reactElement("div", {
            className: join(" ", ["border"]),
        }), reactElement("div", {
            children: props.Description,
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))),
        Classes: props.Classes,
        Controls: ofArray([createElement(TextButton, {
            ComponentState: componentState,
            Label: t("general.cancel"),
            OnClick: props.OnClose,
            TestId: "confirmation-dialog-onClose-button",
            Variant: "blueButton",
        }), createElement(TextButton, {
            ComponentState: componentState,
            Label: t("general.save"),
            OnClick: () => {
                const matchValue = signaturePad.current;
                if (matchValue == null) {
                }
                else {
                    const signaturePad_1 = matchValue;
                    signaturePad_1.getCanvas().toBlob((blob) => {
                        props.OnConfirm(new File([blob], "signature.png"));
                    });
                }
            },
            TestId: "confirmation-dialog-onConfirm-button",
            Variant: "blueButton",
        })]),
        IsOpen: props.IsOpen,
        OnClose: props.OnClose,
        Title: Title,
    }));
}

